
<template>
    <div>
        <DynamicFormComponent ref="dynamicFormComponent" />
    </div>
</template>

<script>
import DynamicFormComponent from "@/components/DynamicFormComponents/Main.vue";

export default {
    name: "dynamic-form-view",
    components: { DynamicFormComponent },
    title: 'DynamicForm',
    beforeRouteLeave(to, from, next) {
        const formComp = this.$refs.dynamicFormComponent;
        if (formComp && typeof formComp.handleBeforeRouteLeave === 'function') {
            formComp.handleBeforeRouteLeave(next);
        } else {
            next();
        }
    }
}
</script>